import React, { useState, useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { DonationSidebar } from '@/components/layout'

export const DonationSidebarSection = () => {
  const items = [
    { id: 'donate-near-you', label: 'Donate Near You' },
    { id: 'search-by-sponsor', label: 'Search by Sponsor' },
    { id: 'search-by-event', label: 'Search by Event' },
    { id: 'private-drives', label: 'Private Drives' },
    { id: 'search-by-donor-centers', label: 'Search By Donor Centers' },
  ]

  const [selectedId, setSelectedId] = useState('donate-near-you')

  const useMemoSelectedLabel = useMemo(() => {
    return items.find(x => x.id === selectedId)?.label
  }, [selectedId])

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Box sx={{ width: 300 }}>
        <DonationSidebar
          title='Where to Donate:'
          items={items}
          selectedId={selectedId}
          onChange={setSelectedId}
        />
      </Box>

      <Box sx={{ flex: 1, minHeight: 360, p: 2 }}>
        <Typography variant='h6' gutterBottom>
          {useMemoSelectedLabel}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Placeholder content for {useMemoSelectedLabel}.
        </Typography>
      </Box>
    </Box>
  )
}
